import { render } from "./footer.vue?vue&type=template&id=05a0dab9&scoped=true&ts=true"
import script from "./footer.ts?vue&type=script&lang=ts&external"
export * from "./footer.ts?vue&type=script&lang=ts&external"

import "./footer.scss?vue&type=style&index=0&id=05a0dab9&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a0dab9"]])

export default __exports__